import { getAuthAxiosBackend } from "@/helpers/axios"
import { PersonServices } from "@/services/personServices"

class BeneficiaryServices extends PersonServices{    

    getProfileDataByPersonId(id){
        return getAuthAxiosBackend().get('PersonProfile/beneficiaryProfile/' + id.toString())
    }

    addWife(personId, relationship, data){
        return getAuthAxiosBackend().post('familyRelationship/addWife?personID='+personId+'&relationship='+relationship, data)
    }

    addStepmother(personId, relationship, fatherID, data){
        return getAuthAxiosBackend().post('familyRelationship/addStepmother?personID='+personId+'&relationship='+relationship+'&fatherID='+fatherID, data)
    }

    addSonWife(personId, relationship, husbandID, data){
        return getAuthAxiosBackend().post('familyRelationship/addSonWife?personID='+personId+'&relationship='+relationship+'&husbandID='+husbandID, data)
    }

    addSibling(personId, relationship, fatherID, motherID, data){
        return getAuthAxiosBackend().post('familyRelationship/addSibling?personID='+personId+'&relationship='+relationship+'&fatherID='+fatherID+'&motherID='+motherID, data)
    }

    addMother(personId, relationship, data){
        return getAuthAxiosBackend().post('familyRelationship/addMother?personID='+personId+'&relationship='+relationship, data)
    }

    addGrandchildren(personId, relationship, fatherID, motherID, data){
        return getAuthAxiosBackend().post('familyRelationship/addGrandchildren?personID='+personId+'&relationship='+relationship+'&fatherID='+fatherID+'&motherID='+motherID, data)
    }

    addFather(personId, relationship, data){
        return getAuthAxiosBackend().post('familyRelationship/addFather?personID='+personId+'&relationship='+relationship, data)
    }

    addChildren(personId, relationship, motherId, data){
        return getAuthAxiosBackend().post('familyRelationship/addChildren?personID='+personId+'&relationship='+relationship+'&motherID='+motherId, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('familyRelationship/softDeleteFamilyMembers/' + id.toString())
    }
}

export default new BeneficiaryServices()